import { Button } from '@mui/material';
import { CartBarBadgeItem } from './cartBarBadgeItem';
import { openCartDrawer } from '../../redux/reducers/sideBarReducer';
import { useAppDispatch } from '../../redux/hooks';

export function CartBarBadgeButton() {
  const dispatch = useAppDispatch();

  const handleOnClick = () => {
    dispatch(openCartDrawer());
  };

  return (
    <Button
      sx={{
        backgroundColor: 'transparent',
        color: 'primary.contrastText',
        boxShadow: 'none',
        px: '6px',
        '&:hover': {
          boxShadow: 'none',
          backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
      }}
      onClick={handleOnClick}
    >
      <CartBarBadgeItem />
    </Button>
  );
}
